import React, { Component } from 'react';
import { Tooltip } from 'bootstrap';
import { Menus, MenuType, ConfigType } from './DisplayMenus';
import "./PRSMaster.scss";

export class PRSMasterComponent extends Component {
	constructor(props) {
		super(props)

		this.state = { line1: 'Version:', line2: 'PMS V2101010190' };

		this.display = {
			menu: MenuType.Status,
			index: 0,
            cursor: 0,
            editIndex: 0,
			editText: '',
			editing: false,
			blinkTick: false, // Tracks editor cursor blink
		};

		this.panelState = {
			firmwareVersion: '21010190',
			panelCommMode: 1,
			panelPassword: '0000',
			ipAddress: '192.168.002.123',
			subnetMask: '255.255.255.000',
			defaultGateway: '192.168.002.001',
			dns: '192.168.002.001',
			serverConnMode: 1,
			serverAddress: '192.168.002.010',
			serverName: 'SERVER-PC',
			serverPort: "09876",
			panelId: 1,
			panelRunMode: 0,
			panelMacAddress: "AABBCCDDEEFF",
			panelName: 'PRS-Master',
			areaName: 'No Area',
			siteName: 'Default Site',
			networkName: 'PANEL1234',
			httpServerMode: 0,
			siteCodeCount: 1,
			userCount: 20
		}
	}

	componentDidMount() {
		new Tooltip(document.querySelector('#powerInput'), { title: 'Main power input to the controller using 12V-13.5V DC up to 5A.', placement: 'left' })
		new Tooltip(document.querySelector('#batteryInput'), { title: 'Optional connection to a 12VDC lead acid battery. To fully charge the battery, you must use a 13.5V power supply.', placement: 'left' });

		new Tooltip(document.querySelector('#rs485Header1'), { title: 'RS-485 connection to expansion boards 1 & 2.', placement: 'left' })
		new Tooltip(document.querySelector('#rs485Header2'), { title: 'RS-485 connection to expansion boards 3 & 4.', placement: 'left' })

		new Tooltip(document.querySelector('#lightSensor'), { title: 'Light sensor used to detect when the enclosure is opened to trigger tamper sensor alarm.', placement: 'bottom' })

		new Tooltip(document.querySelector('#piezo'), { title: 'Loud buzzer that can be used as an alarm or to play doorbells.', placement: 'bottom' })

		new Tooltip(document.querySelector('#apbModule'), { title: 'Optional memory module is used for storing user locations for Anti-Passback. This module is only required if you wish to enforce Anti-Passback for one or more doors on the controller.', placement: 'bottom' })

		new Tooltip(document.querySelector('#nic'), { title: '10/100Mb Ethernet Connector. Used to communicate with the web server over TCP and UDP on port 9876.', placement: 'bottom' })

		new Tooltip(document.querySelector('#d1LED'), { title: 'CPU Heartbeat LED. This LED blinking indicates the firmware is running.', placement: 'bottom' })


		new ButtonEvent('bottomLeftButton', this.leftDownClick);
		new ButtonEvent('upRightButton', this.topRightClick);

		new ButtonEvent('enterButton', this.enterClick, this.enterLongClick);
		new ButtonEvent('escButton', this.escClick, this.escLongClick);

		setInterval(this.updateDisplay, 2500);
		setInterval(this.draw, 1000);
		this.draw();
	}

	updateDisplay = () => {
		if (this.display.menu != 0)
			return;

		this.display.index++;
		if (this.display.index >= Menus[MenuType.Status].screens.length)
			this.display.index = 0;
	}

    draw = (menu = this.display.menu, newIndex = 0) => {
		var screens = Menus.hasOwnProperty(menu) ? Menus[menu].screens : [];

        if (this.display.menu !== menu) {
            if (this.display.menu === MenuType.Config)
                this.display.editIndex = this.display.index + this.display.cursor; // Add cursor to get correct index of selected config item

            this.display.index = newIndex;
			this.display.cursor = 0;
			this.display.editText = '';
			this.display.editing = false;
			this.display.menu = menu;
		}

		switch (menu) {
			case MenuType.Status:
				this.setState({
					line1: screens[this.display.index].line1(this.panelState),
					line2: screens[this.display.index].line2(this.panelState)
				});
				break;
			case MenuType.Config:
				var endOfMenu = this.display.index + 1 >= screens.length;

				this.setState({
					line1: (this.display.cursor == 0 ? "-" : " ") + screens[this.display.index - (endOfMenu ? 1 : 0)].text,
					line2: (this.display.cursor == 1 ? "-" : " ") + screens[this.display.index + (endOfMenu ? 0 : 1)].text
				});
				break;

			case MenuType.Info:
				this.setState({
					line1: String(this.display.index + 1).padStart(2, '0') + " " + screens[this.display.index].text,
					line2: screens[this.display.index].value(this.panelState)
				})
				break;
			case MenuType.Password:
				if (this.display.editText == '')
					this.display.editText = '0000'

				var line2 = this.display.editText;
				if (this.display.blinkTick) {
					line2 = line2.substring(0, this.display.cursor) + (this.display.editing ? '*' : ' ') + line2.substring(this.display.cursor + 1);
				}
				this.display.blinkTick = !this.display.blinkTick;

				this.setState({
					line1: 'Setup Password?',
					line2: line2
				});
				break;
			case MenuType.AccessGranted:
				this.setState({
					line1: 'Access Granted',
					line2: ''
				});
                this.display.menu = MenuType.Config;
                this.props.onAction(3, null);
				break;
			case MenuType.AccessDenied:
				this.setState({
					line1: 'Access Denied',
					line2: ''
				}) 
				this.display.menu = MenuType.Status;
				break;
            case MenuType.ConfigEdit:
                var configInfo = Menus[MenuType.Config].screens[this.display.editIndex];

				if (this.display.editText == '')
					this.display.editText = this.panelState[configInfo.prop];

				var line2 = this.display.editText;
				if (this.display.blinkTick) {
					line2 = line2.substring(0, this.display.cursor) + (this.display.editing ? '*' : ' ') + line2.substring(this.display.cursor + 1);
				}
				this.display.blinkTick = !this.display.blinkTick;

				this.setState({
					line1: configInfo.text,
					line2: line2
                });
                                
                break;
            case MenuType.ConfigSelect:
                var configInfo = Menus[MenuType.Config].screens[this.display.editIndex];

                if (!this.display.editing) {
                    this.display.editing = true;
                    this.display.index = this.panelState[configInfo.prop];
                }

                this.setState({
                    line1: configInfo.text,
                    line2: this.display.index + ":" + configInfo.items[this.display.index]
                });
                break;
            case MenuType.ChangeConfirm:
                this.setState({
                    line1: "Change Confirm ?",
                    line2: "Yes=Enter, No=Esc"
                });
                break;
            case MenuType.PingIP:
                this.setState({
                    line1: "Ping Server IP",
                    line2: (this.display.cursor ? "Time = 0ms" : this.panelState.serverAddress)
                });
                break;
            case MenuType.PingName:
                this.setState({
                    line1: "Ping Server Name",
                    line2: (this.display.cursor ? "Time = 0ms" : this.panelState.serverName)
                });
                break;
            case MenuType.BoardType:
                this.setState({
                    line1: "Board type",
                    line2: "1: Use Preset DB"
                })
                break;
            case MenuType.BoardAddress:
                this.setState({
                    line1: "Board Address",
                    line2: "01 PRS_IO8"
                });
                break;
            case MenuType.OutputTest:
                this.setState({
                    line1: "1 2 3 4 5 6",
                    line2: "0 0 0 0 0 0"
                });
                break;
            case MenuType.InputTest:
                this.setState({
                    line1: "1 2 3 4 5 6 7 8",
                    line2: "o o o o o o o o"
                });
                break;
            case MenuType.ReaderSampling:
                this.setState({
                    line1: "Reader",
                    line2: "Reader 1"
                });
                break;
            case MenuType.DeleteEventsConfirm:
                this.setState({
                    line1: "Delete Events?",
                    line2: "Yes=Enter,No=Esc"
                });
                break;
            case MenuType.EraseFlashConfirm:
                this.setState({
                    line1: "Erase Flash Mem?",
                    line2: "Yes=Enter,No=Esc"
                });
                break;
            default:
                break;
		}
	}

    escClick = () => {
        switch (this.display.menu) {
            case MenuType.Password:
                // Redirect to AccessGranted or Denied based on panel password
                this.draw(this.display.editText === this.panelState.panelPassword ? MenuType.AccessGranted : MenuType.AccessDenied);
                break;
            case MenuType.ConfigEdit:
                var final = this.display.editText
                this.draw(MenuType.ChangeConfirm);
                this.display.editText = final; // Copy editText back since draw() clears and we need if confirmed
                break;
            case MenuType.ConfigSelect:
                var selection = this.display.index;
                this.draw(MenuType.ChangeConfirm);
                this.display.editText = selection;
                break;
            default:
                if (this.display.editIndex) {
                    this.draw(MenuType.Config, this.display.editIndex);
                    this.display.editIndex = 0;
                    return;
                }

                // If within a menu, revert to default menu
                if (this.display.menu !== 0) {
                    this.display.index = 0;
                    this.draw(0);
                }
                break;
        }
	}

	// Open Info view
	escLongClick = () => {
		this.display.index = 0;
        this.draw(2);
        this.props.onAction(0, null);
	}

    enterClick = () => {
        switch (this.display.menu) {
            case MenuType.ChangeConfirm:
                var configInfo = Menus[MenuType.Config].screens[this.display.editIndex];

                // Update panel state with the new confirmed value
                if (configInfo.type === ConfigType.List) {
                    this.panelState[configInfo.prop] = parseInt(this.display.editText, 10);
                } else {
                    this.panelState[configInfo.prop] = this.display.editText;
                }

                // Send action identifier to lesson so it can complete the step
                if (configInfo.action)
                    this.props.onAction(configInfo.action, this.panelState[configInfo.prop]);

                // Send back to config menu with edited option selected
                this.draw(MenuType.Config, this.display.editIndex);
                break;
            case MenuType.Config:
                var configInfo = Menus[MenuType.Config].screens[this.display.index + this.display.cursor];
                if (configInfo.type === ConfigType.List)
                    this.draw(MenuType.ConfigSelect);
                else {
                    if (configInfo.screen)
                        this.draw(configInfo.screen);
                    else
                        this.draw(MenuType.ConfigEdit);
                }
                break;
            case MenuType.PingIP:
                this.display.cursor = 1; // Set value so draw will show ping "response"
                this.props.onAction(14, null);
                break;
            case MenuType.PingName:
                this.display.cursor = 1; // Set value so draw will show ping "response"
                this.props.onAction(15, null);
                break;
            case MenuType.DeleteEventsConfirm:
                this.props.onAction(20, null);
                this.draw(MenuType.Config, this.display.editIndex);
                break;
            case MenuType.EraseFlashConfirm:
                this.props.onAction(21, null);
                this.draw(MenuType.Status);
                break;
            default:
                // Toggle between edit/select when displaying editable text
                if (this.display.editText.length > 0)
                    this.display.editing = !this.display.editing;
                break;
        }
	}

	enterLongClick = () => {
		this.draw(MenuType.Password);
	}

	leftDownClick = () => {
        var screens = Menus.hasOwnProperty(this.display.menu) ? Menus[this.display.menu].screens : [];

        if (this.display.editText.length > 0) {
            if (!this.display.editing) {
                if (this.display.cursor > 0)
                    this.display.cursor--;

                if (this.display.editText[this.display.cursor] === '.' && this.display.menu === MenuType.ConfigEdit && Menus[MenuType.Config].screens[this.display.editIndex].type === ConfigType.Ip)
                    this.display.cursor--;
            } else {
                var editChar = this.display.editText.charCodeAt(this.display.cursor);

                this.display.editText = this.display.editText.substring(0, this.display.cursor) + String.fromCharCode(editChar - 1) + this.display.editText.substring(this.display.cursor + 1);
            }
        } else if (this.display.menu == MenuType.Config) {
            // Move the cursor down if its up
            if (this.display.cursor == 0) {
                this.display.cursor = 1;
                // Show next config option if cursor is down and theres items to show.
            } else if (this.display.index + 1 < screens.length) {
                this.display.index++;
            }
        } else if (this.display.menu === MenuType.ConfigSelect) {
            if (this.display.index + 1 < Menus[MenuType.Config].screens[this.display.editIndex].items.length)
                this.display.index++;
		} else {
			// Move to the previous info/status message
            this.display.index--;

			// Wrap to last info/status if we've reached the beginning
			if (this.display.index < 0)
                this.display.index = screens.length - 1;

            if (this.display.index === 5) // Actual IP Addr
                this.props.onAction(2, null); // ViewActualIP
            else if (this.display.index === 6)
                this.props.onAction(3, null); // ViewPanelMAC
		}

		console.log('LeftDown Click, Display Index: ' + this.display.index);
		this.draw();
	}

	topRightClick = () => {
        var screens = Menus.hasOwnProperty(this.display.menu) ? Menus[this.display.menu].screens : [];

        if (this.display.editText.length > 0) {
            if (!this.display.editing) {
                if (this.display.cursor <= this.display.editText.length)
                    this.display.cursor++;

                if (this.display.editText[this.display.cursor] === "." && this.display.menu === MenuType.ConfigEdit && Menus[MenuType.Config].screens[this.display.editIndex].type === ConfigType.Ip)
                    this.display.cursor++;
            } else {
                var editChar = this.display.editText.charCodeAt(this.display.cursor);

                this.display.editText = this.display.editText.substring(0, this.display.cursor) + String.fromCharCode(editChar + 1) + this.display.editText.substring(this.display.cursor + 1);
            }
        } else if (this.display.menu === MenuType.Config) {
            // Move the cursor up it its down
            if (this.display.cursor === 1) {
                this.display.cursor = 0;
                // Show previous config option if cursor is up and we aren't at the top
            } else if (this.display.index > 0) {
                this.display.index--;
            }
        } else if (this.display.menu === MenuType.ConfigSelect) {
            if (this.display.index > 0)
                this.display.index--;
        
		} else {
			// Move to the next info/status message
            this.display.index++;

			// Wrap to the first info/status if we've reached the end
			if (this.display.index >= screens.length)
                this.display.index = 0;

            if (this.display.index === 5) // Actual IP Addr
                this.props.onAction(2, null); // ViewActualIP
            else if (this.display.index === 6)
                this.props.onAction(3, null); // ViewPanelMAC
		}

		console.log('UpRight Click, Display Index: ' + this.display.index);
		this.draw();
	}

	render() {
		return (

			<svg
				xmlns="http://www.w3.org/2000/svg"
				id="prsMaster"
				width="728"
				height="278"
				version="1.1"
				viewBox="0 0 728 278"
			>
				<style id="style2191">
					.green-led-slow { } .header-background { } .yellow-led-fast { }{" "}
					.green-led-fast { } .header { } .button { } .innerRing { } .outer { }
				</style>
				<defs id="defs666">
					<clipPath id="clipPath1134" clipPathUnits="userSpaceOnUse">
						<path id="path1132" d="M0 612h792V0H0z"></path>
					</clipPath>
				</defs>
				<g id="g670" transform="matrix(1.33333 0 0 -1.33333 0 816)">
					<g id="pcb">
						<path
							id="path674"
							fill="#318e4e"
							fillOpacity="1"
							fillRule="nonzero"
							stroke="none"
							d="M0 0h-184.943l-11.791 7.419h-123.209l-11-7.419h-214.772v208.166H0V24.851h-9.484V17.95H0z"
							display="inline"
							transform="translate(545.965 403.584)"
						></path>
						<path
							id="path678"
							fill="none"
							stroke="#30844c"
							strokeDasharray="none"
							strokeLinecap="butt"
							strokeLinejoin="miter"
							strokeMiterlimit="10"
							strokeOpacity="1"
							strokeWidth="0.5"
							d="M545.965 403.584H361.022l-11.791 7.419H226.022l-11-7.419H.25V611.75h545.715V428.435h-9.484v-6.901h9.484z"
							display="inline"
						></path>
						<g id="g680" display="inline" transform="translate(-96.353 86.986)">
							<path
								id="path690"
								fill="#d4e5d8"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a6.875 6.875 0 10-13.75 0A6.875 6.875 0 000 0"
								display="inline"
								transform="translate(622.375 514.5)"
							></path>
							<path
								id="path694"
								fill="none"
								stroke="#a3a4a3"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="1"
								d="M622.375 514.5a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
								display="inline"
							></path>
							<path
								id="path698"
								fill="#d4e5d8"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a6.875 6.875 0 10-13.75 0A6.875 6.875 0 000 0"
								display="inline"
								transform="translate(138.375 513.364)"
							></path>
							<path
								id="path702"
								fill="none"
								stroke="#a3a4a3"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="1"
								d="M138.375 513.364a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
								display="inline"
							></path>
							<path
								id="path706"
								fill="#d4e5d8"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a6.875 6.875 0 10-13.75 0A6.875 6.875 0 000 0"
								display="inline"
								transform="translate(138.375 326.65)"
							></path>
							<path
								id="path710"
								fill="none"
								stroke="#a3a4a3"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="1"
								d="M138.375 326.65a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
								display="inline"
							></path>
							<path
								id="path714"
								fill="#d4e5d8"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a6.875 6.875 0 10-13.75 0A6.875 6.875 0 000 0"
								display="inline"
								transform="translate(622.375 326.65)"
							></path>
							<path
								id="path718"
								fill="none"
								stroke="#a3a4a3"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="1"
								d="M622.375 326.65a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
								display="inline"
							></path>
						</g>
						<g
							id="edgeConnector"
							fillOpacity="1"
							fillRule="nonzero"
							stroke="none"
							display="inline"
							transform="translate(-96.353 86.986)"
						>
							<path
								id="path720"
								fill="#856a3c"
								d="M531.567 405.777h14.746v13.224h-14.746z"
								transform="translate(96.353 -86.986)"
							></path>
							<path
								id="path722"
								fill="#efd89d"
								d="M531.567 415.335h14.468v2.59h-14.468z"
								transform="translate(96.353 -86.986)"
							></path>
							<path
								id="path738"
								fill="#efd89d"
								d="M0 0h-11.879a1.295 1.295 0 000 2.589H0A1.294 1.294 0 000 0"
								display="inline"
								transform="translate(641.094 319.747)"
							></path>
							<path
								id="path734"
								fill="#efd89d"
								d="M0 0h-11.879a1.295 1.295 0 000 2.589H0A1.294 1.294 0 000 0"
								display="inline"
								transform="translate(641.094 324.06)"
							></path>
						</g>
						<g id="g6840">
							<path
								id="linkLED"
								fill="#7fff2a"
								strokeDasharray="none"
								strokeWidth="0.474"
								d="M134.281 -561.027H139.68V-557.057H134.281z"
								className="green-led-fast"
								transform="scale(1 -1)"
							></path>
							<path
								id="pwrLED"
								fill="red"
								strokeDasharray="none"
								strokeWidth="0.474"
								d="M112.724 -540.817H118.123V-536.847H112.724z"
								transform="scale(1 -1)"
							></path>
							<path
								id="d2LED"
								fill="#ffcd01"
								fillOpacity="1"
								strokeDasharray="none"
								strokeWidth="0.474"
								d="M142.365 -499.5H147.764V-495.53H142.365z"
								transform="scale(1 -1)"
							></path>
							<path
								id="d1LED"
								fill="#7fff2a"
								strokeDasharray="none"
								strokeWidth="0.474"
								d="M122.604 -499.5H128.003V-495.53H122.604z"
								className="green-led-slow"
								transform="scale(1 -1)"
							></path>
							<path
								id="txLED2"
								fill="#ffcd01"
								fillOpacity="1"
								strokeDasharray="none"
								strokeWidth="0.474"
								d="M297.772 -440.668H303.171V-436.698H297.772z"
								className="yellow-led-fast"
								transform="scale(1 -1)"
							></path>
							<path
								id="rxLED2"
								fill="#7fff2a"
								strokeDasharray="none"
								strokeWidth="0.474"
								d="M297.772 -428.542H303.171V-424.57199999999995H297.772z"
								className="green-led-fast"
								transform="scale(1 -1)"
							></path>
							<path
								id="txLED1"
								fill="#ffcd01"
								fillOpacity="1"
								strokeDasharray="none"
								strokeWidth="0.474"
								d="M87.817 -428.991H93.216V-425.02099999999996H87.817z"
								className="yellow-led-fast"
								transform="scale(1 -1)"
							></path>
							<path
								id="rxLED1"
								fill="#7fff2a"
								strokeDasharray="none"
								strokeWidth="0.474"
								d="M87.817 -416.865H93.216V-412.895H87.817z"
								className="green-led-fast"
								transform="scale(1 -1)"
							></path>
						</g>
						<path
							id="lightSensor"
							fill="#ccc"
							fillOpacity="1"
							strokeDasharray="none"
							strokeWidth="0.75"
							d="M148.652 -447.18H154.939V-437.749H148.652z"
							transform="scale(1 -1)"
						></path>
						<g
							id="piezo"
							fillOpacity="1"
							strokeDasharray="none"
							transform="scale(1 -1)"
						>
							<circle
								id="path6529"
								cx="406.324"
								cy="-562.599"
								r="13.5"
								fill="#333"
								strokeWidth="0.75"
							></circle>
							<circle
								id="path6635"
								cx="406.369"
								cy="-562.442"
								r="3.75"
								fill="gray"
								strokeWidth="1.143"
							></circle>
						</g>
					</g>
					<g id="buttons" display="inline" transform="translate(-96.353 86.986)">
						<g id="escButton" className="button">
							<path
								id="path838"
								fill="#2d2d2b"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M623.79 357.312h-19.48a5.208 5.208 0 00-5.209 5.208v19.481a5.208 5.208 0 005.208 5.208h19.48a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208"
								display="inline"
							></path>
							<path
								id="path842"
								fill="none"
								stroke="#000"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="1"
								d="M623.79 357.312h-19.48a5.208 5.208 0 00-5.209 5.208v19.481a5.208 5.208 0 005.208 5.208h19.48a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208z"
								display="inline"
							></path>
							<path
								id="path846"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M624.725 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676"
								className="innerRing"
								display="inline"
							></path>
							<path
								id="path866"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M604.562 361.585a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.923 0"
								display="inline"
							></path>
							<path
								id="path862"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M626.187 361.585a1.461 1.461 0 10-2.923-.001 1.461 1.461 0 002.923.001"
								display="inline"
							></path>
							<path
								id="path858"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M626.187 382.342a1.461 1.461 0 10-2.923-.001 1.461 1.461 0 002.923.001"
								display="inline"
							></path>
							<path
								id="path854"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M604.562 382.342a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.923 0"
								display="inline"
							></path>
							<path
								id="path850"
								fill="none"
								stroke="#c9c4b1"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="1"
								d="M624.725 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676z"
								className="outer"
								display="inline"
							></path>
						</g>
						<g id="enterButton" className="button">
							<path
								id="path2052"
								fill="#2d2d2b"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M579.041 357.312h-19.48a5.208 5.208 0 00-5.208 5.208v19.481a5.208 5.208 0 005.208 5.208h19.48a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208"
								display="inline"
							></path>
							<path
								id="path2054"
								fill="none"
								stroke="#000"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="1"
								d="M579.041 357.312h-19.48a5.208 5.208 0 00-5.208 5.208v19.481a5.208 5.208 0 005.208 5.208h19.48a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208z"
								display="inline"
							></path>
							<path
								id="path2056"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M579.977 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676"
								className="innerRing"
								display="inline"
							></path>
							<path
								id="path2058"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M559.814 361.585a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.924 0"
								display="inline"
							></path>
							<path
								id="path2060"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M581.439 361.585a1.461 1.461 0 10-2.923-.001 1.461 1.461 0 002.923.001"
								display="inline"
							></path>
							<path
								id="path2062"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M581.439 382.342a1.461 1.461 0 10-2.923-.001 1.461 1.461 0 002.923.001"
								display="inline"
							></path>
							<path
								id="path2064"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M559.814 382.342a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.924 0"
								display="inline"
							></path>
							<path
								id="path2066"
								fill="none"
								stroke="#c9c4b1"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="1"
								d="M579.977 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676z"
								className="outer"
								display="inline"
							></path>
						</g>
						<g id="upRightButton" className="button">
							<path
								id="path774"
								fill="#c2bfbc"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M535.842 357.312H516.36a5.208 5.208 0 00-5.207 5.208v19.481a5.208 5.208 0 005.207 5.208h19.48a5.208 5.208 0 005.209-5.208V362.52a5.208 5.208 0 00-5.208-5.208"
								display="inline"
							></path>
							<path
								id="path778"
								fill="none"
								stroke="#000"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="1"
								d="M535.842 357.312H516.36a5.208 5.208 0 00-5.207 5.208v19.481a5.208 5.208 0 005.207 5.208h19.48a5.208 5.208 0 005.209-5.208V362.52a5.208 5.208 0 00-5.208-5.208z"
								display="inline"
							></path>
							<path
								id="path782"
								fill="#f9f4dc"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M536.777 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676"
								className="innerRing"
								display="inline"
							></path>
							<path
								id="path786"
								fill="none"
								stroke="#c9c4b1"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="0.5"
								d="M536.777 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676z"
								className="outer"
							></path>
							<path
								id="path790"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M516.613 382.342a1.461 1.461 0 10-2.922-.002 1.461 1.461 0 002.922.002"
								display="inline"
							></path>
							<path
								id="path794"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M538.24 382.342a1.462 1.462 0 10-2.925 0 1.462 1.462 0 002.924 0"
								display="inline"
							></path>
							<path
								id="path798"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M538.24 361.585a1.462 1.462 0 10-2.925 0 1.462 1.462 0 002.924 0"
								display="inline"
							></path>
							<path
								id="path802"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M516.613 361.585a1.461 1.461 0 10-2.922-.002 1.461 1.461 0 002.922.002"
								display="inline"
							></path>
						</g>
						<g id="bottomLeftButton" className="button">
							<path
								id="path2089"
								fill="#c2bfbc"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M489.041 357.312h-19.48a5.208 5.208 0 00-5.208 5.208v19.481a5.208 5.208 0 005.207 5.208h19.481a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208"
								display="inline"
							></path>
							<path
								id="path2091"
								fill="none"
								stroke="#000"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="1"
								d="M489.041 357.312h-19.48a5.208 5.208 0 00-5.208 5.208v19.481a5.208 5.208 0 005.207 5.208h19.481a5.208 5.208 0 005.208-5.208V362.52a5.208 5.208 0 00-5.208-5.208z"
								display="inline"
							></path>
							<path
								id="path2095"
								fill="#f9f4dc"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M489.977 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676"
								className="innerRing"
								display="inline"
							></path>
							<path
								id="path2093"
								fill="none"
								stroke="#c9c4b1"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="0.5"
								d="M489.977 372.26c0-5.896-4.78-10.675-10.676-10.675s-10.676 4.78-10.676 10.675c0 5.896 4.78 10.676 10.676 10.676s10.676-4.78 10.676-10.676z"
								className="outer"
								display="inline"
							></path>
							<path
								id="path2097"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M469.813 382.342a1.461 1.461 0 10-2.922-.002 1.461 1.461 0 002.922.002"
								display="inline"
							></path>
							<path
								id="path2099"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M491.439 382.342a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.924 0"
								display="inline"
							></path>
							<path
								id="path2101"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M491.439 361.585a1.462 1.462 0 10-2.924 0 1.462 1.462 0 002.924 0"
								display="inline"
							></path>
							<path
								id="path2103"
								fill="#000"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M469.813 361.585a1.461 1.461 0 10-2.922-.002 1.461 1.461 0 002.922.002"
								display="inline"
							></path>
						</g>
					</g>
					<g id="lcd" display="inline" transform="translate(-96.353 86.986)">
						<path
							id="path868"
							fill="#38a05e"
							fillOpacity="1"
							fillRule="nonzero"
							stroke="#30844c"
							strokeDasharray="none"
							strokeLinecap="butt"
							strokeLinejoin="miter"
							strokeMiterlimit="10"
							strokeOpacity="1"
							strokeWidth="0.5"
							d="M491.983 438.638h-163v83.073h163z"
						></path>
						<path
							id="path870"
							fill="#141716"
							fillOpacity="1"
							fillRule="nonzero"
							stroke="#30844c"
							strokeDasharray="none"
							strokeLinecap="butt"
							strokeLinejoin="miter"
							strokeMiterlimit="10"
							strokeOpacity="1"
							strokeWidth="0.5"
							d="M481.983 450.579h-143v59.348h143z"
						></path>
						<path
							id="path872"
							fill="#d5dde2"
							fillOpacity="1"
							fillRule="nonzero"
							stroke="none"
							d="M475.983 462.934h-130.5v35.054h130.5z"
						></path>
						<g id="g902" display="inline" transform="translate(490.254 516.785)">
							<path
								id="path876"
								fill="#348e51"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a3.421 3.421 0 10-6.843 0A3.421 3.421 0 000 0"
								display="inline"
								transform="translate(-152.74)"
							></path>
							<path
								id="path880"
								fill="none"
								stroke="#eed48d"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="0.5"
								d="M-152.74 0a3.421 3.421 0 10-6.843 0 3.421 3.421 0 006.843 0z"
								display="inline"
							></path>
							<path
								id="path884"
								fill="#348e51"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a3.42 3.42 0 10-6.841.001A3.42 3.42 0 000 0"
								display="inline"
								transform="translate(-152.74 -72.808)"
							></path>
							<path
								id="path888"
								fill="none"
								stroke="#eed48d"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="0.5"
								d="M-152.74-72.808a3.42 3.42 0 10-6.841.001 3.42 3.42 0 006.84-.001z"
								display="inline"
							></path>
							<path
								id="path892"
								fill="#348e51"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a3.42 3.42 0 10-6.841.001A3.42 3.42 0 000 0"
								display="inline"
								transform="translate(.844 -73.457)"
							></path>
							<path
								id="path896"
								fill="none"
								stroke="#eed48d"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="0.5"
								d="M.844-73.457a3.42 3.42 0 10-6.841.002 3.42 3.42 0 006.84-.002z"
								display="inline"
							></path>
							<path
								id="path900"
								fill="#348e51"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a3.42 3.42 0 10-6.842 0A3.42 3.42 0 000 0"
								display="inline"
							></path>
							<path
								id="path904"
								fill="none"
								stroke="#eed48d"
								strokeDasharray="none"
								strokeLinecap="butt"
								strokeLinejoin="miter"
								strokeMiterlimit="10"
								strokeOpacity="1"
								strokeWidth="0.5"
								d="M0 0a3.42 3.42 0 10-6.842 0A3.42 3.42 0 000 0z"
							></path>
						</g>
						<text
							xmlSpace="preserve"
							id="line2Display"
							x="410.051"
							y="-396.322"
							fill="#000"
							fillOpacity="1"
							strokeDasharray="none"
							strokeWidth="0.637"
							display="inline"
							fontFamily="monospace"
							fontSize="15"
							fontStretch="normal"
							fontStyle="normal"
							fontVariant="normal"
							fontWeight="normal"
							textAnchor="middle"
							transform="scale(.85 -1.17648)"
						>
							<tspan
								id="tspan8135"
								x="410.051"
								y="-396.322"
								fill="#000"
								strokeWidth="0.637"
								fontFamily="monospace"
								fontSize="15"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
								textAnchor="start"
							>
								{this.state.line2}
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							id="line1Display"
							x="410.051"
							y="-409.279"
							fill="#000"
							fillOpacity="1"
							strokeDasharray="none"
							strokeWidth="0.637"
							display="inline"
							fontFamily="monospace"
							fontSize="15"
							fontStretch="normal"
							fontStyle="normal"
							fontVariant="normal"
							fontWeight="normal"
							textAnchor="start"
							transform="scale(.85 -1.17648)"
						>
							<tspan
								id="tspan8079"
								x="410.051"
								y="-409.279"
								fill="#000"
								fontFamily="monospace"
								fontSize="15"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
								textAnchor="start"
							>
								{this.state.line1}
							</tspan>
						</text>
					</g>
					<g id="headers">
						<g
							id="batteryInput"
							className="header"
							display="inline"
							transform="translate(-96.353 86.986)"
						>
							<path
								id="path1242"
								fill="#63b47f"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M118.755 411.843H97.936v28.69h20.819z"
								className="header-background"
							></path>
							<path
								id="path1246"
								fill="#2c7039"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0l.192 26.502h14.654v-.554c6.214-7.368.144-12.636.144-12.636S21.213 8.784 14.96.5V0z"
								display="inline"
								transform="translate(100.347 412.965)"
							></path>
							<path
								id="path1250"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a2.02 2.02 0 10-4.04 0A2.02 2.02 0 000 0"
								display="inline"
								transform="translate(110.838 431.691)"
							></path>
							<path
								id="path1254"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a2.02 2.02 0 10-4.038 0A2.02 2.02 0 000 0"
								display="inline"
								transform="translate(110.838 420.482)"
							></path>
							<path
								id="path1256"
								fill="#589f6f"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M100.352 418.56h-2.426v3.845h2.426z"
							></path>
							<path
								id="path1258"
								fill="#589f6f"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M100.352 430.323h-2.426v3.845h2.426z"
							></path>
						</g>
						<g
							id="powerInput"
							className="header"
							display="inline"
							transform="translate(-96.353 86.986)"
						>
							<path
								id="path1224"
								fill="#63b47f"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M118.75 459.865H97.931v28.69h20.819z"
								className="header-background"
							></path>
							<path
								id="path1228"
								fill="#2c7039"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0l.192 26.502h14.654v-.554c6.215-7.368.144-12.636.144-12.636S21.214 8.784 14.96.5V0z"
								display="inline"
								transform="translate(100.337 460.985)"
							></path>
							<path
								id="path1236"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a2.02 2.02 0 10-4.038 0A2.02 2.02 0 000 0"
								display="inline"
								transform="translate(110.829 468.502)"
							></path>
							<path
								id="path1232"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a2.02 2.02 0 10-4.038 0A2.02 2.02 0 000 0"
								display="inline"
								transform="translate(110.829 479.711)"
							></path>
							<path
								id="path1238"
								fill="#589f6f"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M100.343 466.58h-2.426v3.845h2.426z"
							></path>
							<path
								id="path1240"
								fill="#589f6f"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M100.343 478.343h-2.426v3.845h2.426z"
								display="inline"
							></path>
						</g>
						<g
							id="rs485Header1"
							className="header"
							display="inline"
							transform="translate(-96.353 86.986)"
						>
							<path
								id="path1190"
								fill="#63b47f"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M116.881 332.083H97.929v48.085h18.952z"
								className="header-background"
							></path>
							<path
								id="path1218"
								fill="#2c7039"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
								display="inline"
								transform="translate(113.459 342.943)"
							></path>
							<path
								id="path1222"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
								display="inline"
								transform="translate(107.68 339.838)"
							></path>
							<path
								id="path1210"
								fill="#2c7039"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.373H0z"
								display="inline"
								transform="translate(113.459 353.87)"
							></path>
							<path
								id="path1214"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
								display="inline"
								transform="translate(107.68 350.766)"
							></path>
							<path
								id="path1202"
								fill="#2c7039"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
								display="inline"
								transform="translate(113.459 364.798)"
							></path>
							<path
								id="path1206"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
								display="inline"
								transform="translate(107.68 361.693)"
							></path>
							<path
								id="path1194"
								fill="#2c7039"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
								display="inline"
								transform="translate(113.459 375.726)"
							></path>
							<path
								id="path1198"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
								display="inline"
								transform="translate(107.68 372.62)"
							></path>
						</g>
						<g
							id="nic"
							fillOpacity="1"
							fillRule="nonzero"
							stroke="none"
							display="inline"
							transform="translate(-96.353 86.986)"
						>
							<path
								id="path1140"
								fill="#d6d4d3"
								d="M306.772 479h-71.811v39.5h71.811z"
							></path>
							<path
								id="path1148"
								fill="#5f6160"
								d="M0 0h19.516a3.438 3.438 0 100-6.875H0"
								display="inline"
								transform="translate(234.962 490.986)"
							></path>
							<path
								id="path1152"
								fill="#c2bfbc"
								d="M0 0l18.457-.645c1.898 0 3.438-1.292 3.438-2.566v.259c0-1.274-1.54-2.307-3.438-2.307L0-6"
								display="inline"
								transform="translate(234.917 490.5)"
							></path>
							<path
								id="path1156"
								fill="#5f6160"
								d="M0 0h19.517a3.437 3.437 0 000-6.875H0"
								display="inline"
								transform="translate(234.984 511.514)"
							></path>
							<path
								id="path1160"
								fill="#c2bfbc"
								d="M0 0l18.457-.645c1.898 0 3.437-1.292 3.437-2.566v.259c0-1.274-1.539-2.307-3.437-2.307L0-6"
								display="inline"
								transform="translate(234.94 511.028)"
							></path>
						</g>
						<g
							id="addonHeader"
							fillOpacity="1"
							fillRule="nonzero"
							stroke="none"
							clipPath="url(#clipPath1134)"
							display="inline"
							transform="translate(-96.353 86.986)"
						>
							<path
								id="path1166"
								fill="#2d2d2b"
								d="M515.363 407.062h-16.896v37.09h16.896z"
								display="inline"
							></path>
							<g id="g1871" fill="#000" display="inline">
								<path id="path1180" d="M505.135 416.1h-3.834v3.833h3.834z"></path>
								<path id="path1182" d="M512.498 416.1h-3.833v3.833h3.833z"></path>
								<path
									id="path1184"
									d="M505.135 409.258h-3.834v3.833h3.834z"
								></path>
								<path
									id="path1186"
									d="M512.498 409.258h-3.833v3.833h3.833z"
								></path>
								<path
									id="path1168"
									d="M505.135 437.318h-3.834v3.833h3.834z"
									display="inline"
								></path>
								<path
									id="path1170"
									d="M512.498 437.318h-3.833v3.833h3.833z"
									display="inline"
								></path>
								<path
									id="path1172"
									d="M505.135 430.252h-3.834v3.833h3.834z"
									display="inline"
								></path>
								<path
									id="path1174"
									d="M512.498 430.252h-3.833v3.833h3.833z"
									display="inline"
								></path>
								<path
									id="path1176"
									d="M505.135 422.941h-3.834v3.833h3.834z"
									display="inline"
								></path>
								<path
									id="path1178"
									d="M512.498 422.941h-3.833v3.833h3.833z"
									display="inline"
								></path>
							</g>
						</g>
						<g
							id="rs485Header2"
							className="header"
							display="inline"
							transform="translate(239.647 86.986)"
						>
							<path
								id="path3915"
								fill="#63b47f"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M116.881 332.083H97.929v48.085h18.952z"
								className="header-background"
								display="inline"
							></path>
							<path
								id="path3917"
								fill="#2c7039"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
								display="inline"
								transform="translate(113.459 342.943)"
							></path>
							<path
								id="path3919"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
								display="inline"
								transform="translate(107.68 339.838)"
							></path>
							<path
								id="path3921"
								fill="#2c7039"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.373H0z"
								display="inline"
								transform="translate(113.459 353.87)"
							></path>
							<path
								id="path3923"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
								display="inline"
								transform="translate(107.68 350.766)"
							></path>
							<path
								id="path3925"
								fill="#2c7039"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
								display="inline"
								transform="translate(113.459 364.798)"
							></path>
							<path
								id="path3927"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
								display="inline"
								transform="translate(107.68 361.693)"
							></path>
							<path
								id="path3929"
								fill="#2c7039"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
								display="inline"
								transform="translate(113.459 375.726)"
							></path>
							<path
								id="path3931"
								fill="#be9a3a"
								fillOpacity="1"
								fillRule="nonzero"
								stroke="none"
								d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
								display="inline"
								transform="translate(107.68 372.62)"
							></path>
						</g>
					</g>
					<g
						id="labels"
						strokeDasharray="none"
						strokeWidth="0.75"
						fontFamily="monospace"
						fontStretch="normal"
						fontStyle="normal"
						fontVariant="normal"
						fontWeight="normal"
						textAnchor="middle"
					>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text6323"
							x="113.173"
							y="-556.592"
							fill="#fff"
							fillOpacity="1"
							fontSize="7"
							transform="scale(1 -1)"
						>
							<tspan
								id="tspan6321"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="113.173"
								y="-556.592"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="7"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								LINK_ACT
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text6319"
							x="115.363"
							y="-528.916"
							fill="#fff"
							fillOpacity="1"
							fontSize="7"
							transform="scale(1 -1)"
						>
							<tspan
								id="tspan6317"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="115.363"
								y="-528.916"
								fill="#fff"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="7"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								PWR
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text6349"
							x="290.771"
							y="-436.708"
							fill="#fff"
							fillOpacity="1"
							fontSize="7"
							transform="scale(1 -1)"
						>
							<tspan
								id="tspan6347"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="290.771"
								y="-436.708"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="7"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								Tx
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text6353"
							x="290.607"
							y="-424.495"
							fill="#fff"
							fillOpacity="1"
							fontSize="7"
							transform="scale(1 -1)"
						>
							<tspan
								id="tspan6351"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="290.607"
								y="-424.495"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="7"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								Rx
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text6329"
							x="145.34"
							y="-486.805"
							fill="#fff"
							fillOpacity="1"
							fontSize="7"
							transform="scale(1 -1)"
						>
							<tspan
								id="tspan6327"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="145.34"
								y="-486.805"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="7"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								D2
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text5477"
							x="125.411"
							y="-486.897"
							fill="#7fff2a"
							fontSize="7"
							transform="scale(1 -1)"
						>
							<tspan
								id="tspan5475"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="125.411"
								y="-486.897"
								fill="#fff"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="7"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								D1
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text6361"
							x="80.816"
							y="-425.031"
							fill="#fff"
							fillOpacity="1"
							fontSize="7"
							transform="scale(1 -1)"
						>
							<tspan
								id="tspan6359"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="80.816"
								y="-425.031"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="7"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								Tx
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text6365"
							x="80.652"
							y="-412.819"
							fill="#fff"
							fillOpacity="1"
							fontSize="7"
							transform="scale(1 -1)"
						>
							<tspan
								id="tspan6363"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="80.652"
								y="-412.819"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="7"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								Rx
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text6475"
							x="164.371"
							y="-439.994"
							fill="#fff"
							fillOpacity="1"
							fontSize="7"
							transform="scale(1 -1)"
						>
							<tspan
								id="tspan6473"
								x="164.371"
								y="-439.994"
								fill="#fff"
								strokeWidth="0.75"
							>
								LS1
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3909"
							x="614.054"
							y="-390.076"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="matrix(1 0 0 -1 -96.353 86.986)"
						>
							<tspan id="tspan3907" x="614.054" y="-390.076" strokeWidth="0.75">
								SW4
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3841"
							x="516.803"
							y="-432.21"
							fill="#fff"
							display="inline"
							fontSize="10"
							transform="scale(1 -1)"
						>
							<tspan id="tspan3839" x="516.803" y="-432.21" strokeWidth="0.75">
								Esc
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3903"
							x="613.667"
							y="-390.076"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="matrix(1 0 0 -1 -141.101 86.986)"
						>
							<tspan id="tspan3901" x="613.667" y="-390.076" strokeWidth="0.75">
								SW3
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3835"
							x="614.004"
							y="-345.224"
							fill="#fff"
							display="inline"
							fontSize="10"
							transform="matrix(1 0 0 -1 -141.101 86.986)"
						>
							<tspan
								id="tspan3833"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="614.004"
								y="-345.224"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="10"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								Enter
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3851"
							x="525.02"
							y="-390.076"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="matrix(1 0 0 -1 -96.353 86.986)"
						>
							<tspan id="tspan3849" x="525.02" y="-390.076" strokeWidth="0.75">
								SW2
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3827"
							x="525.245"
							y="-343.912"
							fill="#fff"
							display="inline"
							fontSize="16"
							transform="matrix(1 0 0 -1 -96.353 86.986)"
						>
							<tspan id="tspan3831" x="530.061" y="-343.912">
								↑ →{" "}
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3845"
							x="526.237"
							y="-390.076"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="matrix(1 0 0 -1 -143.154 86.986)"
						>
							<tspan
								id="tspan3843"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="526.237"
								y="-390.076"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="8"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								SW1
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text2170"
							x="520.525"
							y="-343.912"
							fill="#fff"
							display="inline"
							fontSize="16"
							transform="matrix(1 0 0 -1 -143.154 86.986)"
						>
							<tspan
								id="tspan2168"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="525.341"
								y="-343.912"
								fill="#fff"
								strokeDasharray="none"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="16"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								{" "}
								← ↓{" "}
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text4041"
							x="127.95"
							y="-429.804"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="matrix(1 0 0 -1 -96.353 86.986)"
						>
							<tspan
								id="tspan4039"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="127.95"
								y="-429.804"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="12"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								-
							</tspan>
							<tspan
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								id="tspan4043"
								x="127.95"
								y="-414.804"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="12"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								+
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
								writingMode: 'vertical-lr',
							}}
							id="text4059"
							x="43.993168"
							y="-512.84369"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="scale (1,-1)"
						>
							<tspan
								id="tspan4057"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
									writingMode: 'vertical-lr',
								}}
								x="43.993168"
								y="-512.84369"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="8"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								BATTERY
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
								writingMode: 'vertical-lr'
							}}
							id="text4025"
							x="43.993168"
							y="-512.84369"
							fill="#fff"
							display="inline"
							fontSize="12"
							transform="scale(1 -1)"
						>
							<tspan
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
									writingMode: 'vertical-lr'
								}}
								id="tspan4033"
								x="43.653038"
								y="-561.03369"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="8"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								INPUT
							</tspan>
							<tspan
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
									writingMode: 'vertical-lr'
								}}
								id="tspan4037"
								x="58.653038"
								y="-561.03369"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="8"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								POWER
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text4019"
							x="127.95"
							y="-478.756"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="matrix(1 0 0 -1 -96.353 86.986)"
						>
							<tspan
								id="tspan4017"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="127.95"
								y="-478.756"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="12"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								-
							</tspan>
							<tspan
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								id="tspan4021"
								x="127.95"
								y="-463.756"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="12"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								+
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3949"
							x="28.281"
							y="-423.866"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="scale(1 -1)"
						>
							<tspan id="tspan3947" x="28.281" y="-423.866" strokeWidth="0.75">
								D-
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3945"
							x="28.281"
							y="-434.893"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="scale(1 -1)"
						>
							<tspan id="tspan3943" x="28.281" y="-434.893" strokeWidth="0.75">
								D+
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3941"
							x="32.863"
							y="-445.668"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="scale(1 -1)"
						>
							<tspan id="tspan3939" x="32.863" y="-445.668" strokeWidth="0.75">
								PWR+
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3937"
							x="33.234"
							y="-456.712"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="scale(1 -1)"
						>
							<tspan id="tspan3935" x="33.234" y="-456.712" strokeWidth="0.75">
								GND-
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3991"
							x="91.635"
							y="-336.88"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="matrix(1 0 0 -1 239.647 86.986)"
						>
							<tspan id="tspan3989" x="91.635" y="-336.88" strokeWidth="0.75">
								D-
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3995"
							x="91.635"
							y="-347.906"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="matrix(1 0 0 -1 239.647 86.986)"
						>
							<tspan id="tspan3993" x="91.635" y="-347.906" strokeWidth="0.75">
								D+
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text3999"
							x="88.717"
							y="-358.682"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="matrix(1 0 0 -1 239.647 86.986)"
						>
							<tspan id="tspan4015" x="88.717" y="-358.682">
								PWR
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text4003"
							x="89.088"
							y="-369.726"
							fill="#fff"
							display="inline"
							fontSize="8"
							transform="matrix(1 0 0 -1 239.647 86.986)"
						>
							<tspan id="tspan4013" x="89.088" y="-369.726">
								GND
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text5535"
							x="114.24"
							y="-581.966"
							fill="#ffcd01"
							fillOpacity="1"
							display="inline"
							fontSize="7"
							transform="scale(1 -1)"
						>
							<tspan
								id="tspan5533"
								style={{
									InkscapeFontSpecification: "'monospace, Normal'",
									fontVariantLigatures: "normal",
									fontVariantCaps: "normal",
									fontVariantNumeric: "normal",
									fontVariantEastAsian: "normal",
								}}
								x="114.24"
								y="-581.966"
								fill="#fff"
								strokeWidth="0.75"
								fontFamily="monospace"
								fontSize="7"
								fontStretch="normal"
								fontStyle="normal"
								fontVariant="normal"
								fontWeight="normal"
							>
								ETHERNET
							</tspan>
						</text>
						<text
							xmlSpace="preserve"
							style={{
								InkscapeFontSpecification: "'monospace, Normal'",
								fontVariantLigatures: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantEastAsian: "normal",
								WebkitTextAlign: "center",
								textAlign: "center",
							}}
							id="text6743"
							x="421.93"
							y="-545.982"
							fill="gray"
							fillOpacity="1"
							fontSize="7"
							transform="scale(1 -1)"
						>
							<tspan
								id="tspan6741"
								x="421.93"
								y="-545.982"
								fill="#fff"
								strokeWidth="0.75"
							>
								BZ1
							</tspan>
						</text>
					</g>
					<g
						id="apbModule"
						display="inline"
						transform="translate(-96.353 86.986)"
					>
						<path
							id="path1270"
							fill="#38a05e"
							fillOpacity="1"
							fillRule="nonzero"
							stroke="none"
							d="M0 0v-21.384c0-5.363 4.348-9.71 9.711-9.71h38.13c5.363 0 9.711 4.347 9.711 9.71V-.753c0 5.363-4.348 9.711-9.711 9.711H9.711V0z"
							display="inline"
							transform="translate(484.914 435.675)"
						></path>
						<path
							id="path1274"
							fill="none"
							fillOpacity="1"
							fillRule="nonzero"
							stroke="#30844c"
							strokeDasharray="none"
							strokeLinecap="butt"
							strokeLinejoin="miter"
							strokeMiterlimit="10"
							strokeOpacity="1"
							strokeWidth="0.5"
							d="M484.914 435.675v-21.384c0-5.363 4.348-9.71 9.711-9.71h38.13c5.363 0 9.711 4.347 9.711 9.71v20.631c0 5.363-4.348 9.711-9.71 9.711h-38.13v-8.958z"
							display="inline"
						></path>
						<path
							id="path1320"
							fill="#2d2d2b"
							fillOpacity="1"
							fillRule="nonzero"
							stroke="none"
							d="M539.75 413.126h-13.648v13.648h13.648z"
							display="inline"
						></path>
						<path
							id="path1318"
							fill="none"
							stroke="#fff"
							strokeDasharray="none"
							strokeLinecap="butt"
							strokeLinejoin="miter"
							strokeMiterlimit="10"
							strokeOpacity="1"
							strokeWidth="0.25"
							d="M514.672 410.084v32.515h-15.255v-35.536h12.455z"
							display="inline"
						></path>
						<g
							id="g1304"
							fill="#c6c5c1"
							fillOpacity="1"
							fillRule="nonzero"
							stroke="none"
							display="inline"
							transform="translate(504.509 410.828)"
						>
							<path
								id="path1306"
								d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
							></path>
							<path
								id="path1310"
								d="M0 0a1.274 1.274 0 10-2.549-.001A1.274 1.274 0 000 0"
								display="inline"
								transform="translate(7.363)"
							></path>
							<path
								id="path1314"
								d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
								display="inline"
								transform="translate(7.363 28.06)"
							></path>
							<path
								id="path1302"
								d="M0 0a1.274 1.274 0 10-2.549-.001A1.274 1.274 0 000 0"
								display="inline"
								transform="translate(7.363 6.841)"
							></path>
							<path
								id="path1298"
								d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
								display="inline"
								transform="translate(0 6.841)"
							></path>
							<path
								id="path1294"
								d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
								display="inline"
								transform="translate(7.363 13.683)"
							></path>
							<path
								id="path1290"
								d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
								display="inline"
								transform="translate(0 13.683)"
							></path>
							<path
								id="path1286"
								d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
								display="inline"
								transform="translate(7.363 20.995)"
							></path>
							<path
								id="path1282"
								d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
								display="inline"
								transform="translate(0 20.995)"
							></path>
							<path
								id="path1278"
								d="M0 0a1.275 1.275 0 10-2.55 0A1.275 1.275 0 000 0"
								display="inline"
								transform="translate(0 28.06)"
							></path>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

class ButtonEvent {
	constructor(htmlId, click, longClick) {
		this.htmlId = htmlId

		this.click = click
		this.longClick = longClick

		this.element = document.getElementById(htmlId)
		this.element.addEventListener('pointerdown', this.onDown);
		this.element.addEventListener('pointerup', this.onUp);
	}

	onDown = () => {
		this.timer = setTimeout(this.timerHandler, 2500);
	}

	onUp = () => {
		if (this.timer != undefined) {
			clearTimeout(this.timer);
			this.timer = undefined;

			this.click(this.htmlId);
		}
	}

	timerHandler = () => {
		if (this.longClick != undefined)
			this.longClick(this.htmlId);
		this.timer = undefined;
	}
}